(function () {
  var root = document.querySelector('[data-tbc-offer]');
  if (!root) return;

  var pill = document.querySelector('[data-tbc-offer-pill]');
  var STATE = 'tbc_offer_state';
  var WHEN = 'tbc_offer_dismissed_at';
  var COOLDOWN = 14 * 24 * 60 * 60 * 1000;

  function read(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function write(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  var posted = !!root.querySelector('[data-tbc-offer-posted]');
  var designMode = root.getAttribute('data-design-mode') === 'true';
  var teardown = function () {};
  var isOpen = false;

  function syncPill() {
    if (pill) pill.hidden = read(STATE) === 'subscribed';
  }

  function onKey(event) {
    if (event.key === 'Escape') close();
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    teardown();
    root.hidden = false;
    // Flush layout so the transition has a starting point to animate from. A rAF would read
    // better, but it gets starved whenever the tab isn't painting, and the panel would then
    // sit at opacity 0 over the whole viewport, swallowing clicks with nothing on screen.
    void root.offsetWidth;
    root.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    var field = root.querySelector('input[type="email"]');
    if (field) setTimeout(function () { field.focus(); }, 300);
  }

  function close() {
    isOpen = false;
    root.classList.remove('is-open');
    setTimeout(function () { root.hidden = true; }, 240);
    document.removeEventListener('keydown', onKey);
    if (read(STATE) !== 'subscribed') {
      write(STATE, 'dismissed');
      write(WHEN, String(Date.now()));
    }
    syncPill();
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-tbc-offer-close]'), function (el) {
    el.addEventListener('click', close);
  });

  if (pill) pill.addEventListener('click', open);

  var copy = root.querySelector('[data-tbc-offer-copy]');
  if (copy) {
    copy.addEventListener('click', function () {
      var done = function () {
        copy.textContent = 'Copied';
        setTimeout(function () { copy.textContent = 'Copy'; }, 2000);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(copy.getAttribute('data-code')).then(done, done);
      } else {
        done();
      }
    });
  }

  if (posted) {
    write(STATE, 'subscribed');
    syncPill();
    open();
    return;
  }

  syncPill();

  if (read(STATE) === 'subscribed') return;

  // The pill is wired up by this point, so returning early still leaves a way back in.
  if (designMode) return;

  var dismissedAt = parseInt(read(WHEN) || '0', 10);
  if (read(STATE) === 'dismissed' && Date.now() - dismissedAt < COOLDOWN) return;

  var timer = setTimeout(open, 10000);

  function onScroll() {
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.7) open();
  }

  function onExit(event) {
    if (event.clientY <= 0) open();
  }

  teardown = function () {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  if (window.matchMedia('(min-width: 750px)').matches) {
    document.addEventListener('mouseout', onExit);
  }
})();
